import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import * as Styled from "./MultiSelect.styled";
import { stringMapDefault } from "./MultiSelectToggle.stringMap";
const componentName = "MultiSelectToggle";
export const MultiSelectToggle = forwardRef((props, ref) => {
    const { children, disabled, labelId, stringMap: stringMapProp, isOpen, required, ...otherProps } = props;
    const stringMap = useStringMap(componentName, { stringMapDefault, stringMapProp });
    return (_jsxs(Styled.Toggle, { ref: ref, priority: "secondary", isOpen: isOpen, type: "button", "data-testid": "MultiSelectToggle", disabled: disabled, "aria-labelledby": labelId ? `${labelId} ${props.children ? props.id : ""}` : props.id, "aria-label": labelId ? undefined : stringMap.toggleMenu, "aria-required": required || undefined, ...otherProps, children: [_jsx(Styled.Plus, { "aria-hidden": "true", children: "+" }), " ", children] }));
});
MultiSelectToggle.displayName = componentName;
